<template>
  <div class="portfoliocomparer">
    <div v-if="portfolioid === 0 || portfolioid === null || portfolioid === undefined || portfolioid === ''" class="container-comparables-not-selected">
      {{ $t("first-select-upload-portfolio-strats") }}
    </div>
    <div v-if="portfolioid !== 0 && portfolioid !== null && portfolioid !== undefined && portfolioid !== ''" v-loading="loading" class="stratslist">
      <div class="portfolioselectorcompare">
        <span> {{ $t('portfoliocomparelist') }}: </span>
        <brainsSelector
          v-model="compareportfolioid"
          :placeholder="$t('portfoliosSelector.select-portfolio') + '*'"
          :list="userportfolios"
          :list-key="'id'"
          :list-label="'portfolioName'"
          :loading="loading"
        />
      </div>
      <div v-if="compareportfolioid" class="portfoliocomparetables">
        <div class="row row-gap--5 mb-3">
          <div class="col-2">
            <span>{{ $t("surface") }}</span>
            <el-select v-model="areaopt" class="mt-05" :placeholder="$t('select-area')">
              <el-option v-for="item in currentportfolio.stratsConfig.areaoptions" :key="item.id" :label="item.name" :value="item.id">
                {{ item.name }}
              </el-option>
            </el-select>
          </div>
          <div class="col-2">
            <span>{{ $t("value") }}</span>
            <el-select v-model="value1opt" class="mt-05" :placeholder="$t('stratsData.select-value') + ' 1'">
              <el-option v-for="item in currentportfolio.stratsConfig.valueoptions" :key="item.id" :label="item.name" :value="item.id">
                {{ item.name }}
              </el-option>
            </el-select>
          </div>
        </div>
        <button class="brains-btn-download btninline" @click="downloadCompareStrats()">{{ $t('export') }} <font-awesome-icon icon="download" /></button>
        <div class="tablecomparationcontainer">
          <comparetable v-for="(table, index) in tables" :key="index" ref="stratstablecontainer" :groupdata="table" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import brainsSelector from '@/components/designComponents/brainsAutocomplete'
import comparetable from '@/components/portfoliocomparetable'
import { DownloadGenericTableAsXlsx } from '@/api/comparables'
import { _ } from 'vue-underscore'
export default {
  name: 'ComparePortfolio',
  components: {
    brainsSelector, comparetable
  },
  data() {
    return {
      loading: false,
      compareportfolioid: null,
      tables: [],
      areaopt: null,
      value1opt: null
    }
  },
  computed: {
    ...mapState('portfolio', {
      portfolioid: (state) => state.currentportfolio.id,
      userportfolios: (state) => state.userportfolios,
      currentportfolio: (state) => state.currentportfolio,
      compareportfolio: (state) => state.compareportfolio
    })
  },
  watch: {
    compareportfolioid: function() {
      this.loadcomparer()
    },
    areaopt: function() {
      this.loadtables()
    },
    value1opt: function() {
      this.loadtables()
    }
  },
  methods: {
    downloadCompareStrats() {
      const vm = this
      vm.downloadGenericTables(vm.$refs.stratstablecontainer.map((item) => {
        return 'stratstablecomp' + item._uid
      }))
    },
    downloadGenericTables(tableClasses) {
      // debugger
      var tableAsArray = []
      var rowSpanControl = {}
      tableClasses.forEach((tableClass, index) => {
        var tableDOM = document.querySelector('.' + tableClass)
        var childElements = tableDOM.childNodes

        for (var i = 0; i < childElements.length; i++) {
          if (childElements[i].localName === 'thead' || childElements[i].localName === 'tbody' || childElements[i].localName === 'tfooter') {
            var tableSection = childElements[i].childNodes
            for (var j = 0; j < tableSection.length; j++) {
              tableAsArray.push(iterateRow(tableSection[j]))
            }
          } else {
            tableAsArray.push(iterateRow(childElements[i]))
          }
        }
      })

      function iterateRow(rowNode) {
        var arrayToAdd = []
        var colsInRow = rowNode.childNodes

        for (var k = 0; k < colsInRow.length; k++) {
          if (!!rowSpanControl[k] && rowSpanControl[k] > 1) {
            arrayToAdd.push('')
            rowSpanControl[k] = rowSpanControl[k] - 1
          }
          if (colsInRow[k].rowSpan > 1) {
            rowSpanControl[k] = colsInRow[k].rowSpan
          }
          for (var y = 0; y < colsInRow[k].colSpan; y++) {
            arrayToAdd.push(y === 0 ? colsInRow[k].innerText : '')
          }
        }
        return arrayToAdd
      }

      DownloadGenericTableAsXlsx(tableAsArray)
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/octet-stream' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'TableExport.xlsx'
          link.click()
        })
    },
    loadtables() {
      const vm = this
      vm.tables = []
      let area_ = vm.areaopt
      if (!vm.areaopt) {
        area_ = vm.currentportfolio.stratsConfig.areaoptions[0]
      } else {
        area_ = vm.currentportfolio.stratsConfig.areaoptions.find((item) => { return item.id === area_ })
      }
      let value_ = vm.value1opt
      if (!vm.value1opt) {
        value_ = vm.currentportfolio.stratsConfig.valueoptions[0]
      } else {
        value_ = vm.currentportfolio.stratsConfig.valueoptions.find((item) => { return item.id === value_ })
      }
      vm.currentportfolio.stratsConfig.groupoptions.forEach(element => {
        var group = _.groupBy(vm.currentportfolio.data, element.id)
        var groupcompare = _.groupBy(vm.compareportfolio.data, element.id)
        vm.tables.push({
          port1: {
            groupdata: group,
            name: vm.currentportfolio.name
          },
          port2: {
            groupdata: groupcompare,
            name: vm.compareportfolio.name
          },
          groupname: element.name,
          area: area_,
          value: value_
        })
        // debugger
      })
    },
    loadcomparer() {
      const vm = this
      if (!vm.compareportfolioid) {
        // debugger
        return
      }
      vm.loading = true

      vm.$store.dispatch('portfolio/loadcompareportfolio', vm.compareportfolioid).then(() => {
        vm.loadtables()
        vm.loading = false
        // debugger
      }).catch(() => {
        vm.loading = false
        vm.$message({
          message: vm.$t('portfoliosSelector.errorloadingportfolios'),
          type: 'error'
        })
      })
    }
  }
}
</script>

<style scoped>
.portfolioselectorcompare .brainsSelector-wrapper {
  display: inline-block;
}
.portfoliocomparer {
  padding: 5px;
}
.portfoliocomparetables {
  /*margin-top: 10px;*/
}
.tablecomparationcontainer {
  max-height: 65vh;
  overflow: auto;
}
</style>
